import React from "react";
import { Check, ShieldCheck } from "lucide-react";
import { REMEMBER_DAY_OPTIONS } from "@/utils/deviceInfo";

const RememberMeField = ({ isDark, checked, rememberDays, onCheckedChange }) => {
  const dayLabel = rememberDays > 0
    ? REMEMBER_DAY_OPTIONS.find((o) => o.days === rememberDays)?.label || `${rememberDays} gün`
    : null;

  return (
    <label
      className={`login3-remember ${isDark ? "login3-remember--dark" : "login3-remember--light"}${checked ? " login3-remember--active" : ""}`}
    >
      <input
        type="checkbox"
        className="login3-remember-input"
        checked={checked}
        onChange={(e) => onCheckedChange(e.target.checked)}
        data-testid="login-remember-checkbox"
      />
      <span className="login3-remember-track">
        <span className="login3-remember-box" aria-hidden="true">
          <Check className="login3-remember-check" strokeWidth={3} />
        </span>

        <span className="login3-remember-copy">
          <span className="login3-remember-title">
            <ShieldCheck className="login3-remember-icon" strokeWidth={2.2} />
            Beni hatırla
          </span>
          <span className="login3-remember-hint">
            {dayLabel ? `${dayLabel} otomatik giriş` : "Bu cihazda tekrar sormadan giriş"}
          </span>
        </span>

        {dayLabel && <span className="login3-remember-badge">{dayLabel}</span>}
      </span>
    </label>
  );
};

export default RememberMeField;
